import { isAndroidWebView, isIOSWebView } from "utils/webViewDetection"

const FOOD_JOURNAL_DAILY_MEALS_CHANGED = "FOOD_JOURNAL_DAILY_MEALS_CHANGED"

export const notifyLogOutToIOSApp = (refreshToken: string) => {
  ;(window as any)?.webkit?.messageHandlers?.IOS_BRIDGE?.postMessage({
    message: "LOGOUT_FROM_FOOD_JOURNAL_WEB",
  })
  ;(window as any)?.webkit?.messageHandlers?.IOS_BRIDGE?.postMessage({
    message: "FOOD_JOURNAL_TOKEN_EXPIRED",
    refreshToken,
  })
}

export const notifyLogOutToAndroidApp = (refreshToken: string) => {
  ;(window as any)?.AndroidBridge?.postMessage(
    JSON.stringify({
      message: "LOGOUT_FROM_FOOD_JOURNAL_WEB",
    }),
  )
  ;(window as any)?.AndroidBridge?.postMessage(
    JSON.stringify({
      message: "FOOD_JOURNAL_TOKEN_EXPIRED",
      refreshToken,
    }),
  )
}

const notifyFoodMountedToIOSApp = () => {
  ;(window as any)?.webkit?.messageHandlers?.IOS_BRIDGE?.postMessage({
    message: "FOOD_JOURNAL_READY_FOR_LOGIN",
  })
}

const notifyFoodMountedToAndroidApp = () => {
  ;(window as any)?.AndroidBridge?.postMessage(
    JSON.stringify({
      message: "FOOD_JOURNAL_READY_FOR_LOGIN",
    }),
  )
}

export const notifyAppToLogOut = (refreshToken: string) => {
  if (isIOSWebView()) {
    notifyLogOutToIOSApp(refreshToken)
  } else if (isAndroidWebView()) {
    notifyLogOutToAndroidApp(refreshToken)
  }
}

export const notifyFoodMountedToApp = () => {
  if (isIOSWebView()) {
    notifyFoodMountedToIOSApp()
  } else if (isAndroidWebView()) {
    notifyFoodMountedToAndroidApp()
  }
}

const notifyFoodLoggedToIOSApp = () => {
  ;(window as any)?.webkit?.messageHandlers?.IOS_BRIDGE?.postMessage({
    message: "FOOD_JOURNAL_FOOD_LOGGED",
  })
}

const notifyFoodLoggedToAndroidApp = () => {
  ;(window as any)?.AndroidBridge?.postMessage(
    JSON.stringify({
      message: "FOOD_JOURNAL_FOOD_LOGGED",
    }),
  )
}

export const notifyFoodLoggedToApp = () => {
  if (isIOSWebView()) {
    notifyFoodLoggedToIOSApp()
  } else if (isAndroidWebView()) {
    notifyFoodLoggedToAndroidApp()
  }
}

const notifyDailyMealsChangedToIOSApp = () => {
  ;(window as any)?.webkit?.messageHandlers?.IOS_BRIDGE?.postMessage({
    message: FOOD_JOURNAL_DAILY_MEALS_CHANGED,
  })
}

const notifyDailyMealsChangedToAndroidApp = () => {
  ;(window as any)?.AndroidBridge?.postMessage(
    JSON.stringify({
      message: FOOD_JOURNAL_DAILY_MEALS_CHANGED,
    }),
  )
}

export const notifyDailyMealsChangedToApp = () => {
  if (isIOSWebView()) {
    notifyDailyMealsChangedToIOSApp()
  } else if (isAndroidWebView()) {
    notifyDailyMealsChangedToAndroidApp()
  }
}
